import styled from 'styled-components';
import Text from 'v3/components/Text';
import theme from 'v3/theme';

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 24px;
`;

export const SectionTitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SectionIcon = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: ${theme.colors.secondary};
  color: ${theme.colors.primary};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 232px));
  gap: 15px 48px;
  align-items: start;

  a {
    display: block;
    width: 100%;
    max-width: 232px;
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 15px 24px;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const EditButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.secondary_light};
  background: ${theme.colors.white};
  color: ${theme.colors.primary};
  font-size: 13px;
  font-weight: 600;
  transition: 0.2s;

  &:hover {
    background: ${theme.colors.secondary};
  }
`;

export const Wrapper = styled.div`
  flex-flow: row wrap;
  flex-wrap: wrap;
  flex-direction: row;
  display: flex;
  padding: 15px;
  width: 100%;
  max-width: 232px;
  height: 95px;
  border: 1px solid ${theme.colors.secondary_light};
  box-sizing: border-box;
  border-radius: 8px;
  transition: 0.2s;
  &:hover {
    border-color: ${theme.colors.light_blue};
    background-color: ${theme.colors.white};
  }
`;

export const Title = styled(Text)`
  font-weight: bold;
  width: 240px;
  word-wrap: break-word;
  margin-bottom: -5px;
`;

export const AddingWrapper = styled.div`
  align-items: center;
  flex-flow: row wrap;
  flex-wrap: wrap;
  flex-direction: row;
  display: flex;
  padding: 18px;
  width: 232px;
  height: 95px;
  border: 1px dashed ${theme.colors.secondary_light};
  box-sizing: border-box;
  border-radius: 8px;
  transition: 0.2s;
  &:hover {
    background-color: ${theme.colors.secondary};
    border-color: ${theme.colors.light_blue};
  }
`;

export const RecentsWrapper = styled.div`
  align-items: center;
  flex-flow: row wrap;
  flex-wrap: wrap;
  flex-direction: row;
  display: flex;
  padding: 25px;
  width: 232px;
  height: 95px;
  border: 1px solid ${theme.colors.secondary_light};
  box-sizing: border-box;
  border-radius: 8px;
`;
